// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__KncLp","tabContainer":"Tabs_tabContainer__VmHFl","active":"Tabs_active__htYJ3","tab":"Tabs_tab__VdsEj"};